import { Alert, Stack } from '@mui/material';
import { FormikErrors, FormikValues } from 'formik';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  errors: FormikErrors<FormikValues>;
  validateOnChange: boolean;
}

const useStyles = createUseStyles({
  formMessage: {
    paddingTop: 2,
    paddingBottom: 2,
  },
});

const FormMessage: FC<Props> = ({ errors, validateOnChange }) => {
  const styles = useStyles();
  const hasErrors = Boolean(Object.keys(errors).length) && validateOnChange;
  return (
    <Stack direction="row" alignItems="center" height="100%" color="error">
      {hasErrors && (
        <Alert severity="error" className={styles.formMessage}>
          Please resolve the above errors
        </Alert>
      )}
    </Stack>
  );
};

export default FormMessage;
